import React from 'react';
import { useMobile } from '@/features/shared/contexts/MobileContext';
import { useAuth } from '@/contexts/FirebaseAuthContext';
import MobilePayoutsPage from '@/features/shared/components/MobilePayoutsPage';
import DesktopPayoutsPage from '@/features/shared/components/DesktopPayoutsPage';
import { Card, CardContent } from '@/components/ui/card';
import { ShieldCheck } from 'lucide-react';
import { ysr2Mobile } from '@/features/shared/styles/mobileDesignSystem';

const PayoutsPage = () => {
    const mobile = useMobile();
    const { profile } = useAuth();
    
    // Check if artist is fully agent-managed (80_20 split)
    const isAgentManaged = profile?.agent_id && profile?.agent_payout_preference === '80_20';
    
    if (isAgentManaged) {
      return (
        <div className={`${mobile.isMobile ? ysr2Mobile.shell : 'bg-transparent'} flex flex-col items-center justify-center min-h-[50vh] p-6 text-center`}>
          {mobile.isMobile && <div className={ysr2Mobile.orbBlue} />}
          {mobile.isMobile && <div className={ysr2Mobile.orbPurple} />}
          <Card className={`${mobile.isMobile ? ysr2Mobile.surfaceStrong : 'bg-gray-900 border-blue-500/30'} relative z-10 max-w-md w-full`}>
            <CardContent className="pt-10 pb-8 flex flex-col items-center">
              <div className="w-16 h-16 rounded-2xl bg-blue-500/15 border border-blue-300/25 flex items-center justify-center mb-6">
                <ShieldCheck className="w-8 h-8 text-blue-200" />
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">Agent Managed Payouts</h2>
              <p className="text-gray-400">
                Your payouts and revenue split are handled directly by your booking agent. 
                Please contact them for any questions regarding your earnings from Your Song Request.
              </p>
            </CardContent>
          </Card>
        </div>
      );
    }

    // Return mobile version if on mobile device
    if (mobile.isMobile) {
        return <MobilePayoutsPage />;
    }

    // Return desktop version
    return <DesktopPayoutsPage />;
};

export default PayoutsPage;
